<template>
    <section class="uk-grid uk-grid-collapse" uk-grid="uk-grid" uk-height-viewport="offset-top: true">
        <main class="uk-width-expand uk-height-1-1">
            <AppHeader />
            <AppMain />
            <AppFooter />
        </main>

        <aside class="uk-width-1-1 uk-width-large@m">
            <AppSidebar uk-sticky />
        </aside>
    </section>
</template>

<script>
import AppHeader from "./components/app/Header";
import AppFooter from "./components/app/Footer";
import AppMain from "./components/app/Main";
import AppSidebar from "./components/app/Sidebar";
import AppCart from "./components/app/Cart";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppMain,
        AppSidebar,
        AppCart
    },
    data() {
        return {
            //
        }
    }
};
</script>

<style></style>
